export var VisualType;
(function (VisualType) {
    VisualType["Bubble"] = "bubble";
    VisualType["BubbleSingleAxis"] = "bubbleSingleAxis";
    VisualType["Candlestick"] = "candlestick";
    VisualType["Boxplot"] = "boxplot";
    VisualType["Circle"] = "circle";
    VisualType["Generic"] = "generic";
    VisualType["Heatmap"] = "heatmap";
    VisualType["Histogram"] = "histogram";
    VisualType["Map"] = "map";
    VisualType["Sankey"] = "sankey";
    VisualType["ScatterMap"] = "scatter_map";
    VisualType["Combination"] = "combination";
    VisualType["Table"] = "table";
    VisualType["Forecast"] = "forecast";
})(VisualType || (VisualType = {}));
//# sourceMappingURL=visualType.js.map